module.exports = __webpack_public_path__ + "static/media/pendingInactive.b349d80f.svg";